export interface TicketAttachment {
  id: number;
  articleId: number;
  ticketId: number;
  filename: string;
  size: number;
  mimeType: string;
}

export interface TicketTimelineEvent {
  date: string;
  title: string;
  description: string;
  icon: string;
  attachments?: TicketAttachment[];
}

export interface Ticket {
  id: string;
  title: string;
  category: string;
  subcategory: string;
  status: "open" | "in_progress" | "resolved" | "closed";
  priority: "low" | "medium" | "high" | "critical";
  createdAt: string;
  updatedAt: string;
  description: string;
  assignedTo: string;
  timeline: TicketTimelineEvent[];
}

export const mockTickets: Ticket[] = [
  {
    id: "TK-2026-0001",
    title: "Laptop no enciende después de actualización",
    category: "Hardware",
    subcategory: "Laptop / Notebook",
    status: "in_progress",
    priority: "high",
    createdAt: "2026-06-10 09:15",
    updatedAt: "2026-06-11 14:30",
    description: "Después de instalar la actualización de BIOS, la laptop Dell Latitude 5540 no enciende. La luz del cargador parpadea en naranja. Ya intenté desconectar la batería y mantener presionado el botón de encendido por 30 segundos sin éxito.",
    assignedTo: "Carlos Mendoza",
    timeline: [
      {
        date: "2026-06-10 09:15",
        title: "Ticket creado",
        description: "El ticket fue registrado en el sistema Zamaad",
        icon: "ri-add-circle-line",
      },
      {
        date: "2026-06-10 09:22",
        title: "Asignado a técnico",
        description: "Carlos Mendoza (Soporte Hardware N2) tomó el caso",
        icon: "ri-user-received-line",
      },
      {
        date: "2026-06-10 11:45",
        title: "Diagnóstico en progreso",
        description: "Se solicitó equipo de reemplazo temporal mientras se diagnostica la falla de BIOS",
        icon: "ri-search-eye-line",
      },
      {
        date: "2026-06-11 14:30",
        title: "Actualización de estado",
        description: "Se identificó corrupción en chip BIOS. Se está reprogramando con herramienta externa. ETA: 2 horas",
        icon: "ri-tools-line",
      },
    ],
  },
  {
    id: "TK-2026-0002",
    title: "No puedo acceder al VPN corporativo",
    category: "Redes",
    subcategory: "VPN / Acceso Remoto",
    status: "open",
    priority: "medium",
    createdAt: "2026-06-12 08:00",
    updatedAt: "2026-06-12 08:00",
    description: "Desde esta mañana no logro conectarme al VPN corporativo usando GlobalProtect. El error dice 'Portal not found'. Ya verifiqué mi conexión a internet y reinicié la computadora. Otros compañeros en la oficina tampoco pueden conectarse.",
    assignedTo: "Sin asignar",
    timeline: [
      {
        date: "2026-06-12 08:00",
        title: "Ticket creado",
        description: "El ticket fue registrado en el sistema Zamaad",
        icon: "ri-add-circle-line",
      },
    ],
  },
  {
    id: "TK-2026-0003",
    title: "Office 365 solicita activación constante",
    category: "Software",
    subcategory: "Office 365 / Correo",
    status: "resolved",
    priority: "low",
    createdAt: "2026-06-08 14:20",
    updatedAt: "2026-06-09 16:45",
    description: "Cada dos días, Word y Excel me piden activar la licencia de Office 365 nuevamente. Ya intenté cerrar sesión y volver a iniciar, pero el problema persiste. Mi cuenta corporativa es mperez@empresa.com.",
    assignedTo: "Andrea López",
    timeline: [
      {
        date: "2026-06-08 14:20",
        title: "Ticket creado",
        description: "El ticket fue registrado en el sistema Zamaad",
        icon: "ri-add-circle-line",
      },
      {
        date: "2026-06-08 14:35",
        title: "Asignado a técnico",
        description: "Andrea López (Soporte Software) tomó el caso",
        icon: "ri-user-received-line",
      },
      {
        date: "2026-06-09 10:15",
        title: "Diagnóstico",
        description: "Se detectó conflicto de licencias por múltiples cuentas de Microsoft vinculadas al mismo dispositivo",
        icon: "ri-search-eye-line",
      },
      {
        date: "2026-06-09 16:45",
        title: "Resuelto",
        description: "Se desvincularon cuentas personales y se reasignó licencia corporativa E3. Usuario confirmó que ya no aparece el mensaje de activación",
        icon: "ri-check-double-line",
      },
    ],
  },
  {
    id: "TK-2026-0004",
    title: "Pantalla azul frecuente al usar AutoCAD",
    category: "Software",
    subcategory: "Sistema Operativo",
    status: "in_progress",
    priority: "high",
    createdAt: "2026-06-11 11:30",
    updatedAt: "2026-06-12 07:45",
    description: "Al trabajar con archivos grandes de AutoCAD 2025, la computadora muestra pantalla azul (BSOD) con error MEMORY_MANAGEMENT. Ocurre 3-4 veces al día. Tengo 32GB de RAM y Windows 11 Pro. Los drivers de gráficos están actualizados.",
    assignedTo: "Ricardo Núñez",
    timeline: [
      {
        date: "2026-06-11 11:30",
        title: "Ticket creado",
        description: "El ticket fue registrado en el sistema Zamaad",
        icon: "ri-add-circle-line",
      },
      {
        date: "2026-06-11 11:40",
        title: "Asignado a técnico",
        description: "Ricardo Núñez (Soporte Software N3) tomó el caso por criticidad",
        icon: "ri-user-received-line",
      },
      {
        date: "2026-06-12 07:45",
        title: "Análisis de volcado",
        description: "Se analizó el archivo de volcado de memoria. Se detectó posible falla en módulo RAM. Se programó visita técnica para cambio de módulos",
        icon: "ri-file-search-line",
      },
    ],
  },
  {
    id: "TK-2026-0005",
    title: "Impresora de oficina no imprime en red",
    category: "Hardware",
    subcategory: "Impresora / Scanner",
    status: "closed",
    priority: "medium",
    createdAt: "2026-06-05 09:00",
    updatedAt: "2026-06-05 10:20",
    description: "La impresora HP LaserJet del 3er piso no aparece en la red. Varios compañeros no pueden imprimir. La impresora muestra 'Fuera de línea' en todos los equipos del piso. Ya verificamos que esté encendida y conectada al switch.",
    assignedTo: "Carlos Mendoza",
    timeline: [
      {
        date: "2026-06-05 09:00",
        title: "Ticket creado",
        description: "El ticket fue registrado en el sistema Zamaad",
        icon: "ri-add-circle-line",
      },
      {
        date: "2026-06-05 09:10",
        title: "Asignado a técnico",
        description: "Carlos Mendoza (Soporte Hardware N2) tomó el caso",
        icon: "ri-user-received-line",
      },
      {
        date: "2026-06-05 09:45",
        title: "Diagnóstico",
        description: "Se encontró que el cable de red estaba flojo en el patch panel del rack del 3er piso",
        icon: "ri-search-eye-line",
      },
      {
        date: "2026-06-05 10:00",
        title: "Solución aplicada",
        description: "Se reconectó el cable de red y se reinició el servicio de impresión. La impresora ya responde en red",
        icon: "ri-plug-line",
      },
      {
        date: "2026-06-05 10:20",
        title: "Cerrado",
        description: "Usuarios del 3er piso confirmaron que pueden imprimir correctamente. Caso cerrado",
        icon: "ri-checkbox-circle-line",
      },
    ],
  },
  {
    id: "TK-2026-0006",
    title: "Solicitud de acceso a sistema ERP",
    category: "Software",
    subcategory: "Licencias / Accesos",
    status: "open",
    priority: "low",
    createdAt: "2026-06-12 09:30",
    updatedAt: "2026-06-12 09:30",
    description: "Nuevo ingreso al equipo de finanzas, necesita acceso al módulo de cuentas por pagar del ERP SAP Business One. Ya cuenta con aprobación del Gerente de Finanzas, Lic. Fernando Castillo.",
    assignedTo: "Sin asignar",
    timeline: [
      {
        date: "2026-06-12 09:30",
        title: "Ticket creado",
        description: "El ticket fue registrado en el sistema Zamaad",
        icon: "ri-add-circle-line",
      },
    ],
  },
];

export const statusConfig: Record<string, { label: string; color: string; bg: string; border: string }> = {
  open: {
    label: "Abierto",
    color: "text-accent-700",
    bg: "bg-accent-100",
    border: "border-accent-300",
  },
  in_progress: {
    label: "En Progreso",
    color: "text-primary-700",
    bg: "bg-primary-100",
    border: "border-primary-300",
  },
  resolved: {
    label: "Resuelto",
    color: "text-emerald-700",
    bg: "bg-emerald-100",
    border: "border-emerald-300",
  },
  closed: {
    label: "Cerrado",
    color: "text-foreground-600",
    bg: "bg-background-200",
    border: "border-background-300",
  },
};

export const priorityConfig: Record<string, { label: string; color: string }> = {
  low: { label: "Baja", color: "text-foreground-500" },
  medium: { label: "Media", color: "text-accent-600" },
  high: { label: "Alta", color: "text-amber-600" },
  critical: { label: "Crítica", color: "text-red-600" },
};
